import fetch from "api/utils/enhancedFetch";
import { getProxycadorHost } from "environment";

export const fetchTranslations = (signal) =>
  fetch(`${getProxycadorHost()}/proxycador/api/v1/translations/guardian`, {
    signal,
  }).then((resp) => resp.json());
